import React, { useCallback, useContext, useMemo, useState } from "react";
import { Box, Dialog, DialogContent, FormControl, FormControlLabel, FormLabel, IconButton, InputAdornment, MenuItem, Radio, RadioGroup, TextField, Typography } from '@mui/material'
import ModAccName from 'components/ModAccName';
import { DialogFooter, DialogHeader } from 'components/dialog/DialogHeader';
import { initDialogData } from "../pages/Menu3/AddJobOrderExpense/initData";
import { validate } from "utils";
import PaperComponent from "components/PaperComponent";
import { useEffect } from "react";
import ComboBox from "components/ComboBox";
import { expenseJobOrderApiNm, expenseJobOrderColNm } from "constants/expenseJobOrderConstant";
import { subcontractExpenseColNm } from "constants/subcontractConstant";
// import useFinanceMsData from "hooks/useFinanceMsData";
import { BoxFC, BoxFR } from "components/BoxCustom";
import useDialogOpen from "hooks/useDialogOpen";
import { grey } from "@mui/material/colors";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import { AutoAwesomeRounded } from "resource/muiImport";
import { DesktopDatePicker } from "@mui/x-date-pickers-pro";


/**
 * AS 2025-05-08 this Dialog use in only for subcontract 
 * After change expid get data from expPoi
 */
const ExpenseJobOrderDialog = ({ state, fn, getApiName }) => {
  const { msData } = useContext(GlobalStateContext);
  // const { msData } = useFinanceMsData();

  const { dialogOpen, selectedExpId, joData } = state
  const { setDialogOpen, deleteExpenseJobOrder, insertUpdateExpenseJobOrder } = fn
  const [dialogData, setDialogData] = useState(initDialogData)


  const apiName = getApiName || expenseJobOrderApiNm.getExpenseJobOrder;
  const key = apiName === expenseJobOrderApiNm.getExpenseJobOrder ? "ExpJobOrdId" : "ScExpId"
  const isSubcontract = key === "ScExpId"

  useDialogOpen(dialogOpen, selectedExpId, apiName, key, setDialogData, initDialogData)

  const validation = useMemo(() => ({
    ExpNm: dialogData.ExpNm === ''
  }), [dialogData]);

  const comboProp = useCallback((name, label, options) => ({
    options: options,
    label: label,
    required: true,
    disabled: selectedExpId !== 0,
    sx: { width: "100%" },
    selectedId: dialogData.ExpId,
    setSelectedId: (id) => setDialogData(o => {

      const found = msData.expensePOIs?.find(exp => (!exp.ExpId || exp.ExpId === id)
        && (!exp.JobId || exp.JobId === joData.JobId)
        && (!exp.POIId || [joData.TakePOIId, joData.LocPOIId, joData.RtnPOIId].includes(exp.POIId))
        && (!exp.ContSize || exp.ContSize === joData.ContSize)
        && (!exp.ContType || exp.ContType === joData.ContType)
        && (!exp.ShpmTypId || exp.ShpmTypId === joData.ShpmTypId)
        && (!exp.TlrTypId || exp.TlrTypId === joData.TlrTypId)
      )

      const vatPrct = +(found?.VatPrct || 0)
      const whtPrct = +(found?.WhtPrct || 0)
      if (found) {
        return {
          ...o,
          ExpId: id,
          IsCost: found.IsCost,
          UntPrB4Vat: Math.round(found.UntPr / (1 + +vatPrct / 100) * 100) / 100,
          UntPr: found.UntPr,
          VatPrct: vatPrct,
          WhtPrct: whtPrct,
          IsOwnRcpt: found.IsOwnRcpt,
          WhtPayrTyp: whtPrct > 0 ? (o.WhtPayrTyp || (+found.IsOwnRcpt === 1 ? "O" : "A")) : null,
          WhtTypId: whtPrct > 0 ? (o.WhtTypId || (whtPrct === 1 ? 1 : 5)) : null,
        }
      }

      const expObj = msData.expObj[id]
      if (expObj) {
        const expWhtPrct = +(expObj.WhtPrct || 0)
        return {
          ...o,
          ExpId: id,
          UntPrB4Vat: Math.round(expObj.UntPr / (1 + +(expObj.VatPrct || 0) / 100) * 100) / 100,
          UntPr: expObj.UntPr,
          VatPrct: expObj.VatPrct,
          WhtPrct: expObj.WhtPrct,
          IsOwnRcpt: expObj.IsOwnRcpt,
          WhtPayrTyp: expWhtPrct > 0 ? (o.WhtPayrTyp || (+expObj.IsOwnRcpt === 1 ? "O" : "A")) : null,
          WhtTypId: expWhtPrct > 0 ? (o.WhtTypId || (expWhtPrct === 1 ? 1 : 5)) : null,
        }
      }
      return { ...o, ExpId: id }

    })
  }), [dialogData, msData, setDialogData, selectedExpId, joData])

  const dialogDataProp = useCallback((name) => ({
    variant: 'outlined',
    size: 'small',
    name: name,
    label: expenseJobOrderColNm[name],
    value: dialogData[name] ?? "",
    error: validation[name],
    onChange: (e) => {
      setDialogData((oldState) => {
        let total = oldState.Total
        if (e.target.name === "Qty") {
          total = oldState.UntPr * e.target.value
        } else if (e.target.name === "UntPr") {
          total = oldState.Qty * e.target.value
        }
        const newState = { ...oldState, [name]: e.target.value, Total: total }
        if (name === "WhtPrct") {
          const whtPrct = +e.target.value
          if (whtPrct > 0) {
            if (!oldState.WhtPayrTyp) newState.WhtPayrTyp = +oldState.IsOwnRcpt === 1 ? "O" : "A"
            if (!oldState.WhtTypId) newState.WhtTypId = whtPrct === 1 ? 1 : 5
          } else {
            newState.WhtPayrTyp = null
            newState.WhtTypId = null
          }
        }
        return newState
      })
    }
  }), [dialogData, validation])

  const calculateVat = useCallback((isB4Vat) => (e) => {
    setDialogData(o => {
      const amnt = +e.target.value
      const newAmnt = isB4Vat ? amnt + amnt * +o.VatPrct / 100 : amnt / (1 + +o.VatPrct / 100)
      if (isB4Vat) {
        return { ...o, UntPr: Math.round(newAmnt * 100) / 100, Total: newAmnt * +o.Qty }
      } else {
        return { ...o, UntPrB4Vat: Math.round(newAmnt * 100) / 100, Total: amnt * +o.Qty }
      }
    })
  }, [])

  const handleAddWhtPrct = useCallback(() => {
    setDialogData(o => ({
      ...o,
      WhtPrct: 3,
      VatPrct: 7,
      WhtPayrTyp: "A",
      WhtTypId: 5,
      UntPrB4Vat: Math.round(o.UntPr / (1 + 7 / 100) * 100) / 100,
      Total: o.UntPr * +o.Qty
    }))
  }, [])

  const handleVatPrctChange = useCallback((e) => {
    setDialogData(o => ({
      ...o, VatPrct: e.target.value,
      UntPrB4Vat: Math.round(o.UntPr / (1 + +e.target.value / 100) * 100) / 100,
      Total: o.UntPr * +o.Qty
    }))
  }, [])
  useEffect(() => {
    if (dialogOpen === false) {
      setDialogData(initDialogData)
    }
  }, [dialogOpen])

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='xs' >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="ค่าใช้จ่าย"
        onDeleteClick={selectedExpId > 0 ? () => deleteExpenseJobOrder(selectedExpId) : null}
      />
      <DialogContent>
        <Box display='flex' flexDirection='column' gap={1} mt={2}>
          <ComboBox {...comboProp("ExpId", expenseJobOrderColNm.ExpNm, msData.expCombo)} />
          {/* <TextField {...dialogDataProp('IsCost')} select fullWidth label="รายได้-ต้นทุน" disabled={selectedExpId !== 0}
            required sx={{ bgcolor: dialogData.IsCost ? red[50] : green[50] }}>
            <MenuItem value={0}>รายได้</MenuItem>
            <MenuItem value={1}>ต้นทุน</MenuItem>
          </TextField> */}
          <TextField {...dialogDataProp('UntPrB4Vat')} sx={{ backgroundColor: grey[200] }}
            type="number" label={<Typography>ราคา {<strong>ก่อน</strong>} Vat</Typography>}
            onBlur={calculateVat(true)} inputProps={{ style: { textAlign: "right" } }}
            onFocus={(e) => e.target.select()} />

          <TextField {...dialogDataProp('UntPr')} type="number"
            label={<Typography>ราคา {<strong>หลัง</strong>} Vat</Typography>}
            onBlur={calculateVat(false)} inputProps={{ style: { textAlign: "right" } }}
            onFocus={(e) => e.target.select()} />
          <TextField {...dialogDataProp('Qty')} inputProps={{ style: { textAlign: "right" } }} />
          <TextField {...dialogDataProp('Total')} inputProps={{ style: { textAlign: "right" } }} disabled />
          <BoxFR>
            <TextField {...dialogDataProp('VatPrct')} sx={{ width: "100%" }} inputProps={{ style: { textAlign: "right" } }}
              onChange={handleVatPrctChange}
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }} />
            <TextField {...dialogDataProp('WhtPrct')} sx={{ width: "100%" }} inputProps={{ style: { textAlign: "right" } }}
              InputProps={{
                startAdornment: <InputAdornment position="start"><IconButton sx={{ p: 0 }} onClick={handleAddWhtPrct}><AutoAwesomeRounded /></IconButton></InputAdornment>,
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }} />
          </BoxFR>
          {dialogData.WhtPrct > 0 &&
            <BoxFC sx={{ gap: 1 }}>
              <BoxFR>
                <TextField {...dialogDataProp('WhtPayrTyp')} label="ผู้หัก ณ ที่จ่าย" select sx={{ width: "100%" }}>
                  <MenuItem value={"A"}>กระทำการแทน</MenuItem>
                  <MenuItem value={"O"}>บริษัททำการหัก</MenuItem>
                  <MenuItem value={"C"}>ลูกค้าทำการหัก</MenuItem>
                </TextField>
                <TextField {...dialogDataProp('WhtTypId')} label="ประเภทหัก" select sx={{ width: "100%" }}>
                  {msData.whtTypeCombo?.map((option) => (
                    <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                  ))}
                </TextField>
              </BoxFR>
              <BoxFR>
                {!isSubcontract &&
                  <DesktopDatePicker label="วันที่" value={dialogData.DocDte}
                    renderInput={(params) => <TextField {...params} sx={{ width: "100%" }} size="small" />}
                    onChange={(newValue) => setDialogData(o => ({ ...o, DocDte: newValue }))} />
                }
                <TextField fullWidth {...dialogDataProp('TotalAfterWht')} label="ยอดหลังหัก ณ ที่จ่าย" inputProps={{ style: { textAlign: "right" } }} disabled
                  value={dialogData.Total - (dialogData.UntPrB4Vat * dialogData.Qty * (dialogData.WhtPrct / 100))} />
              </BoxFR>
            </BoxFC>
          }
          {/* DocNo / DocDte exist only on subcontract_expense */}
          {isSubcontract &&
            <BoxFR>
              <TextField {...dialogDataProp('DocNo')} label={subcontractExpenseColNm.DocNo} sx={{ width: "100%" }} />
              <DesktopDatePicker label={subcontractExpenseColNm.DocDte} value={dialogData.DocDte}
                inputFormat="DD/MM/YYYY" mask="__/__/____"
                renderInput={(params) => <TextField {...params} sx={{ width: "100%" }} size="small" />}
                onChange={(newValue) => setDialogData(o => ({ ...o, DocDte: newValue }))} />
            </BoxFR>
          }
          {
            !dialogData.IsCost &&

            <FormControl component="fieldset">
              <FormLabel component="legend">{expenseJobOrderColNm.IsOwnRcpt}</FormLabel>
              <RadioGroup row name='IsOwnRcpt' value={dialogData.IsOwnRcpt}
                onChange={(e) => { setDialogData((oldState) => ({ ...oldState, IsOwnRcpt: e.target.value })) }}>
                <FormControlLabel value={1} control={<Radio />} label="ใบเสร็จบริษัท" />
                <FormControlLabel value={0} control={<Radio />} label="ใบเสร็จลูกค้า" />
              </RadioGroup>
            </FormControl>
          }
          <ComboBox sx={{ width: "100%" }} options={msData.supplierCombo} label={subcontractExpenseColNm.SupId}
            selectedId={dialogData.SupId}
            setSelectedId={(id) => setDialogData(o => ({ ...o, SupId: id }))} />
          <TextField {...dialogDataProp('Rmk')} multiline rows={3} />
          {
            dialogData.selectedExpId > 0 && <ModAccName modDte={dialogData.ModDte} modAcc={dialogData.ModAcc} />
          }
        </Box>
      </DialogContent>
      <DialogFooter okText={selectedExpId > 0 ? "แก้ไขข้อมูล" : "เพิ่มข้อมูล"}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={() => validate(validation) && insertUpdateExpenseJobOrder(dialogData)} />
    </Dialog>
  )
}

export default React.memo(ExpenseJobOrderDialog)